import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useContext, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { Context, Provider } from './Context';
import { Description } from './Description';
import { Panel } from './Panel';
import { Title } from './Title';
const DialogInner = forwardRef((props, ref) => {
    const { id, isOpen, hasTitle, hasDescription, onClose } = useContext(Context);
    const dialogRef = useRef(null);
    const [delayedIsOpen, setDelayedIsOpen] = useState(isOpen);
    useImperativeHandle(ref, () => dialogRef.current);
    useEffect(() => {
        const dialogElement = dialogRef.current;
        if (!dialogElement) {
            return;
        }
        if (isOpen) {
            dialogElement.showModal();
        }
        else {
            dialogElement.close();
        }
    }, [isOpen]);
    useEffect(() => {
        const dialogElement = dialogRef.current;
        if (!dialogElement) {
            return;
        }
        const handleClose = () => onClose();
        dialogElement.addEventListener('close', handleClose);
        return () => {
            dialogElement.removeEventListener('close', handleClose);
        };
    }, [onClose]);
    useEffect(() => {
        const timer = setTimeout(() => {
            setDelayedIsOpen(isOpen);
        }, 0);
        return () => clearTimeout(timer);
    }, [isOpen]);
    return (_jsx("dialog", { ...props, ref: dialogRef, "aria-labelledby": hasTitle ? `${id}-title` : undefined, "aria-describedby": hasDescription ? `${id}-description` : undefined, "data-open": delayedIsOpen }));
});
DialogInner.displayName = 'Dialog';
const DialogComponent = forwardRef(({ isOpen, onClose = () => { }, id, ...rest }, ref) => {
    return (_jsx(Provider, { onClose: onClose, id: id, isOpen: isOpen, children: _jsx(DialogInner, { ref: ref, ...rest }) }));
});
DialogComponent.displayName = 'Dialog.Provider';
const Dialog = DialogComponent;
Dialog.Description = Description;
Dialog.Panel = Panel;
Dialog.Title = Title;
export { Dialog };
//# sourceMappingURL=Dialog.js.map